import { useEffect } from "react";
import { Link } from "react-router-dom";
import { MaskedLines, FadeUp } from "@/components/Reveal";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found | Green Grade";
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
    return () => {
      const tag = document.querySelector('meta[name="robots"]');
      if (tag) tag.setAttribute("content", "index, follow");
    };
  }, []);

  return (
    <main data-testid="not-found" className="flex min-h-[100svh] flex-col items-center justify-center px-4 py-32 text-center">
      <FadeUp y={12}>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal">404 · Off the grid</p>
      </FadeUp>
      <MaskedLines
        as="h1"
        delay={0.1}
        lines={["Wrong", { text: "coordinates.", lineClass: "italic text-neon" }]}
        className="mt-4 font-display text-5xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-7xl"
      />
      <FadeUp delay={0.2}>
        <p className="mt-6 max-w-md text-base leading-relaxed text-slate-300">
          That page doesn't exist — but the machine control you're after does. Set a new benchmark from here:
        </p>
      </FadeUp>
      <FadeUp delay={0.3}>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="nf-home-link"
            className="group inline-flex items-center gap-3 bg-brand px-8 py-4 font-display text-lg font-bold uppercase tracking-wide text-cream transition-colors hover:bg-signal hover:text-deep"
          >
            Home
          </Link>
          <Link
            to="/hire"
            data-testid="nf-hire-link"
            className="inline-flex items-center gap-3 border border-signal/50 px-8 py-4 font-display text-lg font-bold uppercase tracking-wide text-neon transition-colors hover:bg-signal/10"
          >
            Hire 3D on demand
          </Link>
          <Link
            to="/contact"
            data-testid="nf-contact-link"
            className="inline-flex items-center gap-3 border border-line px-8 py-4 font-display text-lg font-bold uppercase tracking-wide text-white transition-colors hover:border-signal hover:text-neon"
          >
            Contact
          </Link>
        </div>
      </FadeUp>
    </main>
  );
}
